import React from 'react';
import { Link } from 'react-router-dom';
import { APP_CONFIG } from '../config/constants';

export const FinalFooter: React.FC = () => {
  return (
    <footer className="border-t border-gray-700 bg-gray-900 py-6">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Nom de l'application et copyright */}
          <div className="text-center md:text-left">
            <p className="font-semibold text-white mb-1">
              {APP_CONFIG.name}
            </p>
            <p className="text-gray-400 text-xs">
              © 2025 Tous droits réservés
            </p>
          </div>

          {/* Liens légaux seulement */}
          <nav className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-sm">
            <Link 
              to="/confidentialite"
              className="text-gray-400 hover:text-white transition-colors underline text-xs"
            >
              Politique de confidentialité
            </Link>
            <Link 
              to="/conditions"
              className="text-gray-400 hover:text-white transition-colors underline text-xs"
            >
              Conditions d'utilisation
            </Link>
          </nav>

          {/* Développeur */}
          <div className="text-center md:text-right">
            <p className="text-gray-400 text-xs">
              Développé par{' '}
              <a
                href="https://sonny.ch"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 font-medium hover:text-white transition-colors"
              >
                sonny.ch
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
